import React, { useEffect, useState } from 'react';
import { AuthContext } from './context/AuthContext';
import ProfileHeader from './components/ProfileHeader';
import ProfileCard from './components/ProfileCard';
import LoadingIndicator from './components/LoadingIndicator';
import Footer from "./components/Footer";
import './styles/App.css';

// Import Hub from utils in v6
import { Hub } from 'aws-amplify/utils';

import { 
  fetchAuthSession, 
  signOut, 
  signInWithRedirect 
} from 'aws-amplify/auth';

// Debug control - use i.e. DEBUG && console.log("whatever") and set below const true
const DEBUG = process.env.REACT_APP_DEBUG == 'enabled';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated
    checkAuthState();

    // Listen for auth events
    const hubListener = Hub.listen('auth', ({ payload: { event, data } }) => {
      DEBUG && console.log('Auth event:', event);
      
      switch (event) {
        case 'signInWithRedirect':
        case 'signedIn':
          checkAuthState(); // Refresh auth state on sign in
          break;
        case 'signedOut':
          setUser(null);
          break;
        case 'tokenRefresh':
          checkAuthState(); // Refresh auth state on token refresh
          break;
        default:
          break;
      }
    });

    return () => hubListener();
  }, []);

  async function checkAuthState() {
    try {
      setLoading(true);
      // Get current session in v6 style
      const session = await fetchAuthSession();
      
      if (session.tokens) {
        const userAttributes = session.tokens.idToken.payload;
        setUser({
          attributes: userAttributes,
          username: userAttributes.email || userAttributes.sub,
          signInUserSession: session
        });
      } else {
        // No active session, redirect to login
        redirectToLogin();
      }
    } catch (error) {
      console.error('Auth error:', error);
      // If no authenticated user is found, redirect to Cognito hosted UI
      redirectToLogin();
    } finally {
      setLoading(false);
    }
  }

  const redirectToLogin = () => {
    // Use Cognito hosted UI for authentication
    signInWithRedirect();
  };

  const handleSignOut = async () => {
    try {
      // Use global signOut to properly handle OAuth flows
      await signOut({ global: true });
      setUser(null);
    } catch (error) {
      console.error('Error signing out:', error);
      // If there's an error with signOut, try to force reload the page
      window.location.href = '/';
    }
  };

  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      <div className="app-container">
        <div className="background-image"></div>
        <div className="app-content">
          <ProfileHeader onSignOut={handleSignOut} />
          {user ? (
            <ProfileCard user={user} />
          ) : (
            <div className="auth-message">
              <p>Redirecting to login...</p>
            </div>
          )}
        </div>
        <Footer />
      </div>
    </AuthContext.Provider>
  );
}

export default App;